import React, { useMemo } from 'react';

import { useKeyboardShortcuts } from '../hooks/useKeyboardShortcuts';
import { ModalController } from '../modals';
import DialerModal from '../modals/DialerModal';
import SettingsModal from '../modals/SettingsModal';
import LogsModal from '../modals/LogsModal';
import AgentsListModal from '../modals/AgentsListModal';
import KeyboardShortcutsHelpModal from '../modals/KeyboardShortcutsHelpModal';

/**
 * Component that registers global keyboard shortcuts for modals and other global actions
 */
const GlobalKeyboardShortcuts: React.FC = () => {
  const shortcuts = useMemo(
    () => [
      {
        key: 'd',
        description: 'Open Dialer',
        category: 'modals' as const,
        action: () => ModalController.show(DialerModal),
      },
      {
        key: 's',
        description: 'Open Settings',
        category: 'modals' as const,
        action: () => ModalController.show(SettingsModal),
      },
      {
        key: 'l',
        description: 'Open Logs',
        category: 'modals' as const,
        action: () => ModalController.show(LogsModal),
      },
      {
        key: 'a',
        description: 'Open Agents List',
        category: 'modals' as const,
        action: () => ModalController.show(AgentsListModal),
      },
      {
        key: '?',
        shiftKey: true,
        description: 'Show keyboard shortcuts help',
        category: 'general' as const,
        action: () => ModalController.show(KeyboardShortcutsHelpModal),
      },
    ],
    [],
  );

  useKeyboardShortcuts({
    id: 'global-modals',
    shortcuts,
    priority: 5, // Medium priority
  });

  return null;
};

export default GlobalKeyboardShortcuts;
